@import '../../scss/mixin';

.menu {
  @include btn();
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--llm-color-base-900);
  color: var(--llm-color-neutral-100);

  svg {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 2;
  }

  &:disabled,
  &[aria-disabled=true] {
    pointer-events: none;

    svg {
      opacity: 0.4;
    }
  }
}

.backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  background: #E6E0D7;
  color: black;

  @media (min-width: 768px) {
    width: 502px;
  }
}

.head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #CFC9C1;

  @media (min-width: 768px) {
    padding: 24px 32px;
  }
}

.title {
  flex-grow: 1;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #3E3F41;
}

.listing {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  max-height: calc(100% - 65px);
  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (min-width: 768px) {
    padding: 32px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.close {
  @include btn();
}

.empty {
  font-size: larger;
}
